import * as Icons from "lucide-react";
import { Sparkles, type LucideIcon } from "lucide-react";

type Props = { name: string; className?: string };

export default function DevIcon({ name, className }: Props) {
  const Cmp = ((Icons as unknown) as Record<string, LucideIcon>)[name] ?? Sparkles;
  return <Cmp className={className} aria-hidden />;
}